import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import Paginate from '../../components/Paginate'
import SectionHeader from '../../components/SectionHeader'
import patient from '../../stores/patient'
import PlanCard from './PlanCard'
import { observable, action } from 'mobx'
import Button from '../../components/Button'
import PhoneSessionScript from '../../components/PhoneSessionScript'
import Input from '../../components/Input'

const TextArea = styled.textarea`
  background: var(--off-white);
  padding: 0.75rem;
  line-height: 125%;
  overflow-y: auto;
  resize: none;
  height: 15rem;
  width: 100%;
  border: 1px solid transparent;
  display: block;
  &:focus {
    border: 1px solid var(--blue);
  }
`

const OldTextArea = styled.div`
  background: var(--off-white);
  padding: 0.75rem;
  line-height: 125%;
  overflow-y: auto;
  resize: none;
  height: 15rem;
  width: 100%;
  border: 1px solid transparent;
  display: block;
  &:focus {
    border: 1px solid var(--blue);
  }
`

const ScriptWrap = styled.div`
  display: none;
  margin-top: 1rem;
  @media (max-width: 800px) {
    display: block;
  }
`

@observer
export default class PhoneSessionContent extends Component {
  @observable oldPlanNotesShown = false
  @action toggleOldPlanNotes = () => {
    this.oldPlanNotesShown = !this.oldPlanNotesShown
  }

  render() {
    const patientID = patient.fields._id
    
    return (
      <Fragment>
        {/* PLAN NOTES */}
        <SectionHeader color="purple" icon="fas fa-edit" str="titles.planNotes" />
        <Card>
          <Card.Title str="titles.typePlanNotes" />
          <Card.Pad>
            <TextArea
              name="planNotes"
              value={patient.fields.planNotes}
              onChange={patient.setField}
            />
          </Card.Pad>
          <Card.Pad>
              <Input label="Adherence %" />
            </Card.Pad>
        </Card>
        {!!patient.fields.oldPlanNotes && !!patient.fields.oldPlanNotes.length &&
          <Button
            color="blue"
            str={(this.oldPlanNotesShown && "titles.hideOldPlanNotes") || "titles.showOldPlanNotes"}
            onClick={this.toggleOldPlanNotes}
          />
        }
        {this.oldPlanNotesShown && !!patient.fields.oldPlanNotes && patient.fields.oldPlanNotes.map(v => (
          <Card>
            <Card.Pad>
              <i style={{display: 'block', marginBottom: '1rem'}}>{(new Date(v.updated)).toLocaleDateString()}</i>
              <OldTextArea>{v.notes}</OldTextArea>
            </Card.Pad>
          </Card>
        ))}
        <ScriptWrap>
            <PhoneSessionScript />
        </ScriptWrap>
        {/* DAILY ROUTINE */}
        <SectionHeader color="purple" icon="fas fa-calendar-check" str="titles.dailyRoutine" />
        {patient.fields.plans.map((_, i) => <PlanCard key={i} index={i} />)}
        {/* PAGINATE */}
        <Paginate>
          <Paginate.Button
            color="gray"
            str="titles.generateLogin"
            icon="fas fa-print"
            onClick={() => window.open(`/print/${patientID}/login`, '_blank')}
          />
          <Paginate.Button
            color="gray"
            str="titles.printPlan"
            icon="fas fa-print"
            onClick={() => window.open(`/print/${patientID}/plan`, '_blank')}
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhoneSession/PhoneSessionContent.js